/**
 *
 * @param {{any}} assetsObject { key_1: urlSrc_1, key_2: urlSrc_2 }
 * @param {string} assetsKeyPrefix prefix + key
 * @param {Phaser.Scene} sceneContext generally `this`
 * @returns {[string]} [...assetsKeyLoaded]
 */
export const assetsImageLoader = function (
  assetsObject,
  assetsKeyPrefix,
  sceneContext
) {
  const assetsKeyLoaded = []
  Object.keys(assetsObject).forEach((key) => {
    sceneContext.load.image(assetsKeyPrefix + key, assetsObject[key])
    assetsKeyLoaded.push(assetsKeyPrefix + key)
  })
  return [...assetsKeyLoaded]
}


export const assetsSoundsLoader = function (assetsObject,
  assetsKeyPrefix,
  sceneContext) {
  const assetsKeyLoaded = []
  Object.keys(assetsObject).forEach((key) => {
    sceneContext.load.audio(assetsKeyPrefix + key, assetsObject[key])
    assetsKeyLoaded.push(assetsKeyPrefix + key)
  })
  return [...assetsKeyLoaded]
}
/**
 *
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number} value limited between {min} - {max}
 */
export function valueOfBetween(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

/**
 *
 * @param {number} seconds
 * @returns {string} parser time MM:SS
 */
export const seconds2StringFormat = (seconds) => {
  let minutes = Math.floor(seconds / 60)
  let partInSeconds = seconds % 60
  minutes = minutes.toString().padStart(2, '0')
  partInSeconds = partInSeconds.toString().padStart(2, '0')
  return `${minutes}:${partInSeconds}`
}

